import Vue from 'vue';
import Vuex from 'vuex';

import pusher from '@/plugins/pusher';
import builds from '@/store/builds';
import categories from '@/store/categories';
import content from '@/store/content';
import editor from '@/store/editor';
import funders from '@/store/funders';
import history from '@/store/history';
import images from '@/store/images';
import menus from '@/store/menus';
import notifications from '@/store/notifications';
import pageEditor from '@/store/pageEditor';
import pages from '@/store/pages';
import products from '@/store/products';
import redirects from '@/store/redirects';
import tags from '@/store/tags';
import user from '@/store/user';
import { RootState } from '@/types/store';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    baseUrl: process.env.VUE_APP_URL,
  },
  modules: {
    builds,
    content,
    categories,
    editor,
    funders,
    history,
    images,
    notifications,
    menus,
    pages,
    pageEditor,
    products,
    redirects,
    tags,
    user,
  },
  plugins: [pusher],
});
